<template>
    <thead>
        <tr>
            <th
                v-for="(headItemLibelle, headItem) in head"
                :key="headItem"
                :class="{'cursor-pointer': !noOrders}"
                class="text-center"
                @click="orderBy(headItem)"
            >
                {{ headItemLibelle }}
                <i
                    v-if="!noOrders"
                    class="float-right mt-1 fa"
                    :class="getClassOrder(headItem)"
                />
            </th>

            <th
                v-if="!noActions"
                class="text-center"
            >
                Actions
            </th>
        </tr>
    </thead>
</template>

<script>

    export default {
        name: "BaseTableHeader",

        props: {
            head: {type: Object, default: null},
            noActions: Boolean,
            noOrders: Boolean,
            order: {type: String, default: null},
            direction: {type: String, default: null}
        },

        methods : {
            /**
             * Retourne les classes order à affiché pour le champ
             * @param field
             * @return Object
             */
            getClassOrder: function (field) {
                return {
                    'fa-sort text-lighter': this.order !== field,
                    'fa-sort-up text-secondary': this.order === field && this.direction === 'desc',
                    'fa-sort-down text-secondary': this.order === field && this.direction === 'asc',
                }
            },

            /**
             * Order by un champ du head
             * @param field
             */
            orderBy: function (field) {
                if (this.order === field && this.direction !== 'desc') {
                    this.$emit('orderBy', {order: field, direction: 'desc'})
                } else {
                    this.$emit('orderBy', {order: field, direction: 'asc'})
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .table thead th {
        vertical-align : top;
    }
</style>
